export type Link = {
  type: string
  value: string
  isLink: boolean
  href: string
  start: number
  end: number
}

export const formatHardBreaksfromLinks = (links: Link[]): Link[] => {
  const formattedLinks: Link[] = []

  links.forEach((link) => {
    const hrefs = link.href.split('￼')
    link.value.split('￼').forEach((value, index) => {
      const href = hrefs[index]
      if (href === undefined) {
        return
      }
      formattedLinks.push({
        ...link,
        value,
        href,
        start: link.start,
        end: value.length,
      })
    })
  })

  return formattedLinks
}
